import axios from 'axios';
import { API } from '../constants/api-urls';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import { LOCAL_STORAGE_KEYS } from 'common/constants/constants';
import { tz } from 'moment-timezone';

const instance = axios.create({});
const localStorageAccessor = BrowserStorageAccessor().local;

// Add link token interceptor
instance.interceptors.request.use(
  function (config) {
    const token = localStorageAccessor.get(
      LOCAL_STORAGE_KEYS.LINK_ACCOUNT_TOKEN
    );

    if (token) {
      config.headers['link-token'] = token;
      config.headers['X-User-Timezone'] = tz(tz.guess()).format('z');
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export const askInvitation = async account_id =>
  instance.post(`${API.PUBLIC_LINKED_ACCOUNTS}/ask-invitation`, {
    account_id
  });

export const getConnectedSensorNames = async (token, sensorTypeId) =>
  instance.get(
    `${API.PUBLIC_LINKED_ACCOUNTS}/connected-sensors${
      sensorTypeId ? `/${sensorTypeId}` : ''
    }`
  );
